// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5036":"css/app.7043","5359":"css/admin-app.7043"}[chunkId] + ".css";
};